import { Component, EventEmitter, HostListener, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'delete-button',
    templateUrl: './delete-button.component.html',
    styleUrls: ['./delete-button.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class DeleteButtonComponent implements OnInit {

    @Input() deleteButtonText: string = $localize`Delete`;
    @Input() loading: boolean = false;
    @Input() disabled: boolean = false;
    @Input() withAffirmation: boolean = true;
    @Input() overlayTitle: string;
    @Input() overlayDescription: string;
    @Input('itemName') set setItemName(name:string) {
        this.setTitleAndDescription(name);
    }

    @Output() deleteConfirmed = new EventEmitter<void>();

    ngOnInit() {
        this.setTitleAndDescription();
    }

    public showOverlay: boolean = false;
    public modalInput: string = '';
    public inputMatch: boolean = false;
    public modifierKeyHeld: boolean = false;
    public affirmationText = ' ' + $localize`This action cannot be undone. If you are sure, write DELETE in the field below to confirm.`;

    public get canConfirmDelete(): boolean {
        if (!this.withAffirmation) return true;
        return this.inputMatch || this.modifierKeyHeld;
    }

    private setTitleAndDescription(itemName: string = 'this') {
        if(this.overlayTitle && this.overlayDescription) return;
        this.overlayTitle = $localize`Do you want to delete` + ' ' + itemName + '?';
        this.overlayDescription = $localize`Are you absolutely sure you want to delete` + ' ' + itemName + '?';
    }

    @HostListener('document:keydown', ['$event'])
    @HostListener('document:keyup', ['$event'])
    onDocumentKey(event: KeyboardEvent) {
        this.modifierKeyHeld = event.metaKey || event.ctrlKey;
    }

    public onDeleteClick() {
        this.deleteConfirmed.emit();
        this.showOverlay = false;
        this.modalInput = '';
        this.inputMatch = false;
    }

    public onCancelClick() {
        this.showOverlay = false;
        this.modalInput = '';
        this.inputMatch = false;
    }

    public onShowChange(show: boolean) {
        if(show) return;
        this.modalInput = '';
        this.inputMatch = false;
    }

    public matchInput() {
        this.inputMatch = this.modalInput == $localize`DELETE`;
    }
}
